import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  if (response.data.isSyncInProgress == false) {
    $(".cancel").removeClass("disabled");
    $(".confirm").removeClass("disabled");

    swal("Imported!", "Rentals and bookings has been imported!", "success");
    clearInterval(context.interval);
  }
};

// When the request fails
const failed = () => {
  $(".cancel").removeClass("disabled");
  $(".confirm").removeClass("disabled");
  swal("Error!", error.response.data.msg, "warning");
};

export default (context) => {
  return Vue.$http.get('/is-in-progress').then((response) => {
    if (response && response.status === 200) {
      success(response, context);
    }
  }).catch((error) => {
    if (error.response) {
      failed();
    }
  });
};



// WEBPACK FOOTER //
// ./src/app/services/account/checkProgress.js